import {HttpRequest} from '../Data/HttpRequest'
import {PrismaRequestCommentCreate} from '../Entities/PrismaRequestCommentCreate'
import {server} from '../Data/BuildEnvironment'

export function create(
    prismaRequestCommentCreate: PrismaRequestCommentCreate,
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/prisma-request-comments`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(prismaRequestCommentCreate),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/PrismaRequestCommentResource.ts